import { ApolloClient } from '@apollo/client';
import { Flex_FetchGoogleUserQuery, Flex_FetchGoogleUserQueryVariables } from '~/typings/graphql';
import { errors } from '~/utils/error-messages';
import { UnparsedQueryParams } from '../../types';
import { FETCH_GOOGLE_USER } from './handle-google.queries';

export const handleGoogle = async ({
  apolloClient,
  params: { code, state },
  searchString,
}: {
  apolloClient: ApolloClient<{}>;
  params: UnparsedQueryParams;
  searchString: string;
}) => {
  if (!searchString.includes('googleapis')) return;

  // NB: if you pass a path to googleLoginUrl, it returns an encoded state
  const decodedState = JSON.parse(decodeURI(state || '{}'));
  const secureToken = decodedState.secure_token;
  const redirectPath = decodedState.path;

  if (!code || !secureToken) return;

  try {
    const result = await apolloClient.query<
      Flex_FetchGoogleUserQuery,
      Flex_FetchGoogleUserQueryVariables
    >({
      query: FETCH_GOOGLE_USER,
      variables: { code, secureToken },
    });
    const user = result.data.googleUser;
    if (!user) return { error: errors.missingGoogleUser };
    return {
      data: {
        email: user.email,
        firstName: user.firstName ?? undefined,
        lastName: user.lastName ?? undefined,
        redirectPath: redirectPath ?? undefined,
      },
    };
  } catch (e) {
    let error = e.message as string;
    if (error.includes('invalid or expired')) error = errors.expiredGoogleSession;
    return { error };
  }
};
